import * as React from "react";
import { Form, Input, Button, Progress } from "antd";
const FormItem = Form.Item;

import { FormComponentProps } from "antd/lib/form";
import { Mutation, MutationFn } from "react-apollo";
import { Link } from "react-router-dom";
import { RESET_PW_QUERY } from "./queries";
import {
  ResetPassword,
  ResetPasswordVariables
} from "../../../__generated__/types";
import Logo from "../../../components/Logo";

export interface Props extends FormComponentProps {
  location: { state: { token: string } };
}

export interface State {
  loading: boolean;
  done: boolean;
  error: boolean;
  token: string;
}

class ResetMutation extends Mutation<ResetPassword> {}

export class ForgotForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      loading: false,
      done: false,
      error: false,
      token:
        props.location && props.location.state && props.location.state.token
    };
  }

  handleReset(
    event: React.FormEvent<HTMLFormElement>,
    reset: MutationFn<ResetPassword, ResetPasswordVariables>
  ) {
    event.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (reset) {
          if (values.newPassword !== values.newPasswordCheck) {
            this.props.form.setFields({
              newPasswordCheck: {
                value: null,
                errors: [new Error("Passwords do not match")]
              }
            });
            return;
          }
          this.setState({ loading: true, error: false });
          console.log(values);
          reset({
            variables: {
              newPassword: values.newPassword,
              token: this.state.token
            }
          })
            .then(response => {
              this.setState({ loading: false, done: true, error: false });
            })
            .catch(error => {
              console.log("there was an error on reset", error);
              this.props.form.setFields({
                newPassword: {
                  value: null,
                  errors: [new Error("Something went wrong")]
                },
                newPasswordCheck: {
                  value: null,
                  errors: [new Error()]
                }
              });
              this.setState({ loading: false, error: true });
            });
        }
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <ResetMutation mutation={RESET_PW_QUERY}>
        {(reset, { data }) => (
          <Form
            onSubmit={e => this.handleReset(e, reset)}
            className="login-form"
          >
            {this.state.done ? (
              <div style={{ textAlign: "center" }}>
                <Progress type="circle" percent={100} width={80} />
                <p style={{ marginTop: "1em" }}>
                  Succesfully set as new password!
                </p>
                <p style={{ marginTop: "1em" }}>
                  <Link to="/login">Go to login</Link>
                </p>
              </div>
            ) : (
              <React.Fragment>
                <Logo />
                <FormItem label="New password">
                  {getFieldDecorator("newPassword", {
                    rules: [
                      {
                        required: true,
                        message: "Please input your new password!"
                      }
                    ]
                  })(<Input type="password" />)}
                </FormItem>
                <FormItem label="Confirm new password">
                  {getFieldDecorator("newPasswordCheck", {
                    rules: [
                      {
                        required: true,
                        message: "Please input your new password again!"
                      }
                    ]
                  })(<Input type="password" />)}
                </FormItem>
                <FormItem>
                  <Button
                    loading={this.state.loading}
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                  >
                    Set new Password
                  </Button>
                </FormItem>
              </React.Fragment>
            )}
          </Form>
        )}
      </ResetMutation>
    );
  }
}

export default Form.create<Props>()(ForgotForm);



// WEBPACK FOOTER //
// ./src/screens/Login/SetPasswordForm/SetPasswordForm.tsx